// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_app-component_modal__SyN0b","logo":"modal_app-component_logo__sB2bK","review":"modal_app-component_review__0nh2G","webview":"modal_app-component_webview__BbXQI"};